import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import TrashIcon from '../../../Assets/images/delete.svg';

function EmailsList(props) {
  const { list, handleDeleteEmail } = props;
  const columns = [{
    Header: 'Email',
    accessor: 'email',
  }, {
    Header: 'delete',
    accessor: 'delete',
    Cell: (cellProps) => {
      const { original: { email } } = cellProps;
      return (
        <button type="button" className="no--style--button">
          <img src={TrashIcon} alt="trash-icon" width="20px" onClick={() => handleDeleteEmail(email)} />

        </button>
      );
    },

  },
  ];

  return (
    <div className="email__container card">
      <ReactTable
        data={list}
        columns={columns}
        defaultPageSize={5}
        deleteClick={() => { console.log('handle delete called'); }}
      />
    </div>
  );
}
EmailsList.propTypes = {
  list: PropTypes.arrayOf(PropTypes.string),
  handleDeleteEmail: PropTypes.func.isRequired,
};
EmailsList.defaultProps = {
  list: [],
};
export default EmailsList;
